export const DISPLAY_TYPE_OPTIONS = [
  {
    key: 'Overview',
    name: '概览',
    icon: 'icon-view_line'
  },
  {
    key: 'Table',
    name: '表格',
    icon: 'icon-table_line'
  },
]